import styled from 'styled-components';

export const OTPInput = styled.input`
    width: 40px;
    height: 40px;
    padding-left: 6px;
    padding-right: 6px;
    border: 1px solid #a5a5a5;
    border-radius: 8px;
    font-size: 16px;
    text-align: center;

    &:hover {
        padding-left: 6px;
        padding-right: 6px;
    }

    &:focus {
        border-color: #1874fd;
        outline: none;
    }
`;

export const SubmitInput = styled.input`
    padding: 0 24px;
    height: 48px;
    line-height: 18.75px;
    border-radius: 6px;
    border: none;
    outline: none;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    cursor: pointer;
    width: 100%;

    transition: background-color 0.3s ease;
    will-change: background-color;

    color: white;
    background-color: ${({ theme }): string => theme.button.action.default.background};

    &:hover {
        background-color: ${({ theme }): string => theme.button.action.hover.background};
    }

    &:disabled {
        background-color: ${({ theme }): string => theme.button.action.disabled.background};
    }
`;
